<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_terraforming_intro')
}

const isOnResourcesSection = computed(() => {
  return route.path.startsWith('/resources')
})

const goToResources = () => {
  router.push('/resources')
}
</script>

<template>
  <TutorialFrame 
    video-url="https://cdn.ferion.com/videos/advisors/temperate/resources.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.terraforming.intro.builtFirst') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.terraforming.intro.terraformingAllows') }}
      </p>
      <p class="pb-2">
        <strong>{{ t('tutorial.terraforming.intro.toTerraform') }}</strong><br>
        • {{ t('tutorial.terraforming.intro.buildTerraformer') }}<br>
        • {{ t('tutorial.terraforming.intro.collectOre') }}<br>
        • {{ t('tutorial.terraforming.intro.enableTerraforming') }}<br>
      </p>
      <p class="pb-2">
        {{ t('tutorial.terraforming.intro.goToResources') }}
      </p>
    </template>

    <template #alerts>
      <AlertBox type="info" class="hidden md:flex">
        {{ t('tutorial.terraforming.intro.navigateDesktop') }}
      </AlertBox>
      <AlertBox type="info" class="md:hidden">
        {{ t('tutorial.terraforming.intro.navigateMobile') }}
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnResourcesSection" @click="goToResources" class="mr-2">
        {{ t('tutorial.terraforming.intro.goToResourcesBtn') }}
      </ActionButton>
      <ActionButton @click="handleNextStep">
        {{ t('tutorial.terraforming.intro.imThere') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>